import React from "react";
import { Box, Container, Link, Stack, Typography } from "@mui/material";
import { Register } from "../pages/register/Register";
import Footer from "../layout/Footer";
import { RENTLY_LOGO } from "../assets";

const RegisterContainer = () => {
  return (
    <Box
      component="main"
      sx={{
        backgroundImage: `
          linear-gradient(rgba(242, 244, 247, 0.85), rgba(242, 244, 247, 0.85)), 
          url(${RENTLY_LOGO})
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        minHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Central Content Box */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 4, md: 6 },
        }}
      >
        {/* Dynamic Registration Component Card */}
        <Register />
      </Container>

      {/* Footer Block */}
      <Box sx={{ bgcolor: "#ffffff", py: 3, borderTop: "1px solid #ddd" }}>
        <Container maxWidth="md">
          <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ color: "#737373", fontSize: "12px", mb: 1.5 }}>
            <Link href="#" color="inherit" underline="hover">English (UK)</Link>
            <Link href="#" color="inherit" underline="hover">हिन्दी</Link>
            <Link href="#" color="inherit" underline="hover">اردو</Link>
            <Link href="#" color="inherit" underline="hover">मराठी</Link>
          </Stack>
          <Box component="hr" sx={{ border: 0, borderTop: "1px solid #e5e5e5", my: 1 }} />
          <Typography variant="caption" sx={{ color: "#737373", fontSize: "12px" }}>
            Backbenchers: © 2026
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default RegisterContainer;
